import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { nonAuthInstance } from "../services/axiosConfig";
import { isEmpty, isObject, isUndefined, split } from "lodash";
import { getTestStats, getMemberNo } from "../services/ api_services";
import { getCurrentDateString } from "../core/Util";
import Chartt from "../components/Chartt";
import MemberChart from "../components/memberChartt";

export default function Dashboard() {
    const adminOrgId = sessionStorage.getItem("adminOrgId");
    const dbConfig = localStorage.getItem('X-DB-KEY');
    const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

    const { auth } = useAuth();
    const initialCond = {
        sourceUser: "",
        orgId: adminOrgId,
    };

    const periodTypes = [
        { label: "오늘", group: "일별", value: "today" },
        { label: "일주일", group: "주별", value: "week" },
        { label: "30일", group: "월별", value: "30" },
    ];

    const initialTestStatsCond = {
        periodType: periodTypes[0].value,
    };

    const initialTestStats = {
        total_tests: 0,
        total_exec_tests: 0,
        not_exec_tests: 0,
        iphone_y: 0,
        iphone_n: 0,
        android_y: 0,
        android_n: 0,
    };
    const initialTestStats2 = {
        total_count: 0,
        M_count: 0,
        F_count: 0,
    };

    const initialStats = [
        { id: "user_total_cnt", name: "전체 회원권", value: "15,000", unit: "장" },
        { id: "user_remain_cnt", name: "미사용 회원권", value: "0", unit: "장" },
        { id: "user_use_cnt", name: "사용된 회원권", value: "0", unit: "장" },
        { id: "total_cnt", name: "전체 회원권", value: "0", unit: "장" },
        { id: "publish_cnt", name: "발행 회원권", value: "0", unit: "장" },
        { id: "remain_cnt", name: "잔여 회원권", value: "0", unit: "장" },
    ];

    const [cond, setCond] = useState(initialCond);
    const [stats, setStats] = useState(initialStats);
    const [testStats, setTestStats] = useState(initialTestStats);
    const [testStats2, setTestStats2] = useState(initialTestStats2);
    const [testStatsCond, setTestStatsCond] = useState(initialTestStatsCond);
    const [testStatsCond2, setTestStatsCond2] = useState(initialTestStatsCond);
    const [refreshStats, setRefreshStats] = useState(false);
    const [refreshStats2, setRefreshStats2] = useState(false);
    const [refreshTick, setRefreshTick] = useState(0); // 1분 주기 자동 갱신 트리거
    const [daychart, setDaychart] = useState(periodTypes[0].group);
    const [daychart2, setDaychart2] = useState(periodTypes[0].group);

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    // 1분마다 refreshTick 을 올려 아래 조회 effect 들을 다시 돌린다.
    // (예전에는 window.location.reload() 로 화면을 통째로 새로고침해서
    //  선택한 기간·스크롤 위치가 매분 초기화됐다)
    useEffect(() => {
        const interval = setInterval(() => {
            setRefreshTick((prev) => prev + 1);
        }, 60000); // 60000ms = 1분

        // 컴포넌트 언마운트 시 인터벌 제거
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        console.log("useEffect auth", auth, "adminOrgId------>", adminOrgId);
        let condTmp = cond;
        condTmp.sourceUser = auth.admin_seq;
        console.log("condTmp==>", condTmp);
        couponCount(condTmp);
        setCond(condTmp);
    }, [refreshTick]);

    useEffect(() => {
        fetchTestStats();
    }, [testStatsCond.periodType, refreshTick]);

    useEffect(() => {
        fetchmemberno();
    }, [testStatsCond2.periodType, refreshTick]);

    /**
     * 쿠폰 개수 카운트
     * @returns
     */
    const couponCount = async (condTmp) => {
        try {
            const response = await nonAuthInstance.post("org/totalCount", condTmp);
            if (response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                // console.log("🚀 ~ couponCount ~ isArray(response.data):", isObject(response.data));
                if (isObject(response.data)) {
                    const dataKeys = Object.keys(response.data);
                    console.log("🚀 ~ couponCount ~ dataKeys:", dataKeys);
                    dataKeys.map((item) => {
                        updateCountValue(item, response.data[item]);
                    });
                }
            } else {
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    const fetchTestStats = async () => {
        setRefreshStats(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        try {
            console.log("🚀 ~ fetchTestStats ~ testStatsCond:", testStatsCond);
            const response = await getTestStats(testStatsCond);
            console.log("🚀 ~ fetchTestStats ~ response:", response);
            setRefreshStats(false);
            if (response && response.status === 200 && !isEmpty(response.data)) {

                setTestStats((preVal) => {
                    return {
                        ...preVal,
                        total_tests: response.data.total_tests,
                        iphone_y: response.data.iphone_Y,
                        iphone_n: response.data.iphone_N,
                        android_y: response.data.android_Y,
                        android_n: response.data.android_N,

                    }
                });
            } else {
                setTestStats(initialTestStats);
            }
        } catch (e) {
            setRefreshStats(false);
            console.log("e===>", e);
        }
    };

    const fetchmemberno = async () => {
        setRefreshStats2(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        try {
            console.log(testStatsCond2);
            const response = await getMemberNo(testStatsCond2);
            console.log("🚀 ~ fetchmemberno ~ response:", response.data);
            setRefreshStats2(false);
            if (response && response.status === 200 && !isEmpty(response.data)) {
                setTestStats2((preVal) => {
                    return {
                        ...preVal,
                        total_count: Number(response.data[0].male) + Number(response.data[0].female),
                        M_count: response.data[0].male,
                        F_count: response.data[0].female,
                    };
                });
            } else {
                setTestStats2(initialTestStats);
            }
        } catch (e) {
            setRefreshStats2(false);
            console.log("e===>", e);
        }
    };

    const updateCountValue = (id, newVal) => {
        setStats((prevData) => prevData.map((item) => (item.id === id ? { ...item, value: newVal } : item)));
    };

    const handleOnClickPeriodTypes = (val) => {
        setTestStatsCond((preVal) => {
            return {
                ...preVal,
                periodType: val,
            };
        });
    };
    const handleOnClickPeriodTypes2 = (val) => {
        setTestStatsCond2((preVal) => {
            return {
                ...preVal,
                periodType: val,
            };
        });
    };

    const RefreshIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={classNames("w-5 h-5 ", refreshStats ? "animate-spin" : "")}
            >
                <path
                    fillRule="evenodd"
                    d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
                    clipRule="evenodd"
                />
            </svg>
        );
    };
    const RefreshIcon2 = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={classNames("w-5 h-5 ", refreshStats2 ? "animate-spin" : "")}
            >
                <path
                    fillRule="evenodd"
                    d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
                    clipRule="evenodd"
                />
            </svg>
        );
    };

    return (
        <>
            <main>
                <div className="grid grid-cols-2 gap-2 rounded-2xl py-4">
                    <div className="py-4 bg-gray-900 rounded-2xl">
                        {/* Stats */}
                        <span className="ml-4 text-xl font-semibold leading-10 text-white">사용자</span>
                        <div className="bg-gray-900 rounded-2xl gap-0.5 overflow-hidden text-left grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                            {stats.map(
                                (stat, statIdx) =>
                                    split(stat.id, "_")[0] === "user" && (
                                        <div key={statIdx} className={"sm:border-l border-t border-white/5 py-6 px-4 sm:px-6 lg:px-8"}>
                                            <p className="text-sm font-medium leading-6 text-gray-400">{stat.name}</p>
                                            <p className="mt-2 flex items-baseline gap-x-2 ">
                                                <span className="text-4xl font-semibold tracking-tight text-white">{stat.value.toLocaleString()}</span>
                                                <span className="text-sm text-gray-400">{stat.unit}</span>
                                            </p>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                    <div className="py-4 bg-gray-900 rounded-2xl">
                        {/* Stats */}
                        <span className="ml-4 text-xl font-semibold leading-10 text-white">회원권</span>
                        <div className="bg-gray-900 rounded-2xl gap-0.5 overflow-hidden text-left grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                            {stats.map(
                                (stat, statIdx) =>
                                    split(stat.id, "_")[0] !== "user" && (
                                        <div key={statIdx} className={"sm:border-l border-t border-white/5 py-6 px-4 sm:px-6 lg:px-8"}>
                                            <p className="text-sm font-medium leading-6 text-gray-400">{stat.name}</p>
                                            <p className="mt-2 flex items-baseline gap-x-2 ">
                                                <span className="text-4xl font-semibold tracking-tight text-white">{stat.value.toLocaleString()}</span>
                                                <span className="text-sm text-gray-400">{stat.unit}</span>
                                            </p>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
                {/* <div>
                    <h3 className="text-base font-semibold leading-6 text-black">회원</h3>
                    <dl className="mt-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-900 shadow md:grid-cols-3 md:divide-x md:divide-y-0">
                        {userStats.map((stat, statIdx) => (
                            <div key={stat.name} className="px-4 py-5 sm:p-6">
                                <dt className="text-base font-normal text-white">{stat.name}</dt>
                            </div>
                        ))}
                    </dl>
                </div> */}
                <div className="flex">
                    <div className="mt-3 lg:w-2/6 bg-white shadow-md md:divide-y rounded-lg py-4 px-3 overflow-hidden ">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold leading-6 text-gray-900">검사 데이터</h3>
                            <div className="cursor-pointer text-gray-400" onClick={() => fetchTestStats()}>
                                <RefreshIcon />
                            </div>
                            {/* <ArrowPathIcon
                            className="h-5 w-5 text-gray-300 cursor-pointer"
                            aria-hidden="true"
                            onClick={() => fetchTestStats()}
                        /> */}
                        </div>
                        <div className="grid-cols-1 mt-3 py-3">
                            <div className="flex justify-between items-center">
                                <div>
                                    {periodTypes.map((item, index) => {
                                        return (
                                            <div
                                                // id={item.label}
                                                key={item.label}
                                                className={classNames(
                                                    item.value === testStatsCond.periodType
                                                        ? "bg-purple-100 text-purple-700"
                                                        : "bg-gray-100 text-gray-600 ",
                                                    "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium  cursor-pointer",
                                                    index !== 0 ? "ml-2" : ""
                                                )}
                                                onClick={() => {
                                                    handleOnClickPeriodTypes(item.value);
                                                    setDaychart(item.group);
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div>
                                    <span className="inline-flex items-center py-1 text-sm font-normal text-gray-900">오늘 :</span>
                                    <span className="inline-flex items-center px-2 py-1 text-sm font-bold text-gray-900">
                                        {getCurrentDateString()}
                                    </span>
                                </div>
                            </div>
                            <div className="mt-3 py-3 align-middle justify-center text-center">
                                <p className="text-lg font-medium tracking-wide text-gray-700">총 검사</p>
                                <label className="text-7xl text-gray-900 font-bold">{testStats.total_tests}</label>
                            </div>

                            <div className="mt-3 divide-gray-200 grid grid-cols-2 gap-4 divide-x  ">
                                <div className="grid grid-cols-1 text-center">
                                    <label className="text-sm text-gray-700 font-normal">iOS</label>
                                    <span className="text-4xl text-gray-900 font-bold">{testStats.iphone_y}/{testStats.iphone_n}</span>
                                </div>
                                <div className="grid grid-cols-1 text-center">
                                    <label className="text-sm text-gray-700 font-normal">Android</label>
                                    <span className="text-4xl text-gray-900 font-bold">{testStats.android_y}/{testStats.android_n}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 ml-3 lg:w-4/6 bg-white shadow-md md:divide-y rounded-lg py-4 px-3 overflow-hidden ">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold leading-6 text-gray-900"> {isUrinalysis()? '[소변검사]':'[활성산소]'} {daychart} 차트</h3>
                        </div>
                        <div className="grid-cols-1 mt-3 py-3">
                            <Chartt daychart={periodTypes.find((item) => item.group === daychart).value} isUri={isUrinalysis()} refreshKey={refreshTick}/>
                        </div>
                    </div>
                </div>

                <div className="flex py-3">
                    <div className="mt-3 lg:w-2/6 bg-white shadow-md md:divide-y rounded-lg py-4 px-3 overflow-hidden ">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold leading-6 text-gray-900">회원가입 정보</h3>
                            <div className="cursor-pointer text-gray-400" onClick={() => fetchmemberno()}>
                                <RefreshIcon2 />
                            </div>
                        </div>
                        <div className="grid-cols-1 mt-3 py-3">
                            <div className="flex justify-between items-center">
                                <div>
                                    {periodTypes.map((item, index) => {
                                        return (
                                            <div
                                                // id={item.label}
                                                key={item.label}
                                                className={classNames(
                                                    item.value === testStatsCond2.periodType
                                                        ? "bg-indigo-100 text-indigo-700"
                                                        : "bg-gray-100 text-gray-600 ",
                                                    "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium  cursor-pointer",
                                                    index !== 0 ? "ml-2" : ""
                                                )}
                                                onClick={() => {
                                                    handleOnClickPeriodTypes2(item.value);
                                                    setDaychart2(item.group);
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div>
                                    <span className="inline-flex items-center py-1 text-sm font-normal text-gray-900">오늘 :</span>
                                    <span className="inline-flex items-center px-2 py-1 text-sm font-bold text-gray-900">
                                        {getCurrentDateString()}
                                    </span>
                                </div>
                            </div>
                            <div className="mt-3 py-3 align-middle justify-center text-center">
                                <p className="text-lg font-medium tracking-wide text-gray-700">전체 회원가입자</p>
                                <label className="text-7xl text-gray-900 font-bold">{testStats2.total_count}</label> 명
                            </div>
                            <div className="mt-3 divide-gray-200 grid grid-cols-2 gap-4 divide-x  ">
                                <div className="grid grid-cols-1 text-center">
                                    <label className="text-sm text-gray-700 font-normal">사용중 회원</label>
                                    <span>
                                        <span className="text-5xl text-gray-900 font-bold">{testStats2.M_count}</span> 명
                                    </span>
                                </div>
                                <div className="grid grid-cols-1 text-center">
                                    <label className="text-sm text-gray-700 font-normal">심사중 회원</label>
                                    <span>
                                        <span className="text-5xl text-gray-900 font-bold">{testStats2.F_count}</span> 명
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 ml-3 lg:w-4/6 bg-white shadow-md md:divide-y rounded-lg py-4 px-3 overflow-hidden ">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-semibold leading-6 text-gray-900"> [회원가입 정보] {daychart2} 차트</h3>
                        </div>
                        <div className="grid-cols-1 mt-3 py-3">
                            <MemberChart daychart={periodTypes.find((item) => item.group === daychart2).value} refreshKey={refreshTick}/>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
